import * as yup from "yup";

export const schema = yup.object().shape({
    url: yup.string().required("Please input this field").url("Invalid url"),
    active: yup.bool().required(),
});
